class PredictiveSearch extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleExternalClick = this.handleExternalClick.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)

    this.listeners.add(document.documentElement, 'click', this.handleExternalClick)
    this.listeners.add(document, 'keyup', this.handleKeyUp)

    if (this.els.overlay?.element) {
      this.listeners.add(this.els.overlay.element, 'click', this.handleOverlayClick)
    }
  }

  handleExternalClick (event) {
    const trigger = event.target.closest(`[${this._externalElIdentifier}]`)

    if (!trigger) return

    if (this.key) {
      const triggerKey = trigger.getAttribute('key')

      if (triggerKey !== this.key && !this.contains(trigger)) return
    }

    const action = trigger.getAttribute(this._externalElIdentifier)

    if (action === 'toggle') {
      this.handleToggleTrigger()
      return
    }

    if (action === 'close') {
      this.handleCloseTrigger()
    }
  }

  handleToggleTrigger () {
    this.toggleSearch()
  }

  handleCloseTrigger () {
    this.closeSearch()
  }

  handleOverlayClick () {
    if (!this.isOpen) return

    this.closeSearch()
  }

  handleKeyUp (event) {
    const KEYCODE_ESCAPE = 27

    if (
      event.code?.toUpperCase() !== 'ESCAPE' &&
      event.keyCode !== KEYCODE_ESCAPE
    ) {
      return
    }

    if (!this.isOpen) return

    this.closeSearch()
  }

  toggleSearch () {
    if (this.isOpen === false) {
      this.setAttribute('aria-expanded', 'true')
      this.headerEl?.classList.add('hd-Banner-searchActive')
      this.els.input?.element?.focus()
    } else {
      this.closeSearch()
    }
  }

  closeSearch () {
    this.setAttribute('aria-expanded', 'false')
    this.headerEl?.classList.remove('hd-Banner-searchActive')
  }

  get headerEl () {
    return this.externalEls.header?.element
  }

  get isOpen () {
    return this.getAttribute('aria-expanded') === 'true'
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
